import React from 'react';

import { autocompletion, closeBrackets, closeBracketsKeymap, completionKeymap } from '@codemirror/autocomplete';
import { defaultKeymap, history, historyKeymap, indentWithTab } from '@codemirror/commands';
import { json, jsonParseLinter } from '@codemirror/lang-json';
import {
  bracketMatching,
  defaultHighlightStyle,
  foldGutter,
  foldKeymap,
  indentOnInput,
  syntaxHighlighting,
} from '@codemirror/language';
import { linter, lintGutter, lintKeymap } from '@codemirror/lint';
import {
  drawSelection,
  dropCursor,
  highlightActiveLineGutter,
  highlightSpecialChars,
  keymap,
  lineNumbers,
} from '@codemirror/view';
import { SxProps } from '@mui/material';

import BaseCodeMirror from './hoc/BaseCodeMirror';

const JSON_EDITOR = [
  linter(jsonParseLinter()),
  lintGutter(),
  lineNumbers(),
  highlightActiveLineGutter(),
  highlightSpecialChars(),
  history(),
  foldGutter(),
  drawSelection(),
  dropCursor(),
  indentOnInput(),
  syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
  bracketMatching(),
  closeBrackets(),
  autocompletion(),
  keymap.of([
    ...closeBracketsKeymap,
    ...defaultKeymap,
    ...historyKeymap,
    ...foldKeymap,
    ...completionKeymap,
    ...lintKeymap,
    indentWithTab,
  ]),
  json(),
];

type Props = {
  sx?: SxProps;
  defaultValue: string;
  onChange: (v: string) => void;
};
export default function CodeMirrorJsonEditor({ defaultValue, onChange, sx }: Props) {
  return (
    <BaseCodeMirror
      defaultValue={defaultValue}
      onChange={onChange}
      extensions={[JSON_EDITOR]}
      sx={{
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: 1,
        '& .cm-gutters': { borderRadius: 1 },
        ...sx,
      }}
    />
  );
}
